import React, { useEffect } from "react";
// import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom'
import '../css/pyp.css'

import HorizontalTabs from '../components/HorizontalTabs';
import FaPypFaq from '../components/Pyp-faq'
import { useLocation } from 'react-router-dom';
import { useParams } from "react-router-dom";

function Pyp() {
  const { tab } = useParams();
  console.log("Current tab from URL:", tab);  // Debugging line

  const formattedTab = tab ? tab.replace(/-/g, " ") : "IB Primary Years Programme";
  
  // Renamed to start with an uppercase letter
  const location = useLocation();

  // Scroll to the section if specified in the URL state
  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        // Use smooth scrolling to the section
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);



  const tabs = [
  


    { title: 'Ib Primary Years Programme', content: () => <div>

<div id='IbpypCurriculum' className='cam-lower-sec'>

  <div className='Footer-top'>
    <div className='footop-img'>
    {/* <div className='footer-img-box'>
      <img src='../img/british-council.webp'/>
    </div> */}
    <div className='footer-img-box'>
    <img src='../img/pyp-programme-logo.webp'/>
      </div>
   
    
    </div>
    
    </div>

  
    <h1 className='title'>IB Primary Years Programme</h1>
     <p>School appreciates and encourages a childhood that’s driven by curiosity and creativity. As a premier IB school in Jaipur, it is authorised to implement the International Baccalaureate Primary Years Programme (PYP). This also provides a context to build our unique curriculum with concept-driven units.</p>

     <br/>
     <br/>
     <h1 className='title'>What is International Baccalaureate Primary Years Programme (IB PYP)?</h1>
     <p>The PYP is one of the four programmes offered by the International Baccalaureate and is designed for students from ages 3 to 12 years. The PYP prepares students to become active, caring, and lifelong learners who demonstrate respect for themselves and others and have the capacity to participate in the world around them. It focuses on developing the child’s curiosity, both within and beyond the classroom.</p>
     <h1 className='title'>The Learner in IBPYP:</h1>
     <p>Learners have voice, choice and ownership of their learning in PYP. The learning community supports agency and fosters stronger sense of self-efficacy. Sanskar School fosters a stronger sense of self-efficacy in learners by giving them ownership of their own learning through various platforms.</p>
     <p><b>For more information please visit at:</b><a href="https://www.ibo.org/programmes/primary-years-programme/" target="_blank"> https://www.ibo.org</a></p>
     <div className='ibpyp-learner-img'> 
     <img src='../img/newpyp-model-en.webp'/>
     <p>IBPYP Curriculum Framework Model. © International Baccalaureate Organization 2024</p>
     </div>

    </div>


    </div> },

    { title: 'PYP Curriculum at Sanskar', content: () => <div>

<div className='cam-lower-sec'>
  <div className='Footer-top'>
    <div className='footop-img'>
    {/* <div className='footer-img-box'>
      <img src='../img/british-council.webp'/>
    </div> */}
    <div className='footer-img-box'>
    <img src='../img/pyp-programme-logo.webp'/>
      </div>
   
    
    </div>
    
    </div>
    <h1 className='title'>Curriculum at Sanskar</h1>
     <p>At Sanskar School, our curriculum is thoughtfully designed to integrate five essential elements:
Concepts, Knowledge, ATL (Approaches to Learning) Skills, Learner Profile Attributes, and Action. The
knowledge component is nurtured through inquiry-based learning, exploring six transdisciplinary
themes of global significance, fostering a holistic and interconnected understanding of the world.</p>
     
     <p><b>Who We Are: </b> An inquiry into the nature of the self; beliefs and values; personal, physical, mental, social and spiritual health; human relationships including families, friends, communities, and cultures; rights and responsibilities; what it means to be human.</p>
     
     <p><b>Where We Are in Place and Time:</b> An inquiry into orientation in place and time; personal histories; homes and journeys; the discoveries, explorations and migrations of humankind; the relationships between and the interconnectedness of individuals and civilizations, from local and global perspectives.</p>

     <p><b>How We Express Ourselves:</b> An inquiry into the ways in which we discover and express ideas, feelings, nature, culture, beliefs and values; the ways in which we reflect on, extend and enjoy our creativity; our appreciation of the aesthetics.</p>

     <p><b>How the World Works: </b>  An inquiry into the natural world and its laws; the interaction between the natural world (physical and biological) and human societies; how humans use their understanding of scientific principles; the impact of scientific and technological advances on society and on the environment.</p>

     <p><b>How We Organize Ourselves:</b> An inquiry into the interconnectedness of human-made systems and communities; the structure and function of organizations; societal decision-making; economic activities and their impact on humankind and the environment.</p>

     <p><b>Sharing the Planet:</b>  An inquiry into rights and responsibilities in the struggle to share finite resources with other people and with other living things; communities and the relationships within and between them; access to equal opportunities; peace and conflict resolution.</p>
     <br/>

     <p>These themes are selected for their relevance in the real world. They are described as transdisciplinary because they focus on issues that go beyond classroom subjects, and also help facilitators to develop a programme of inquiry.</p>

     <p>The PYP facilitators at Sanskar School identify and develop significant ideas that require learners to have a substantial level of involvement. This framework ensures that students examine each theme, participate in leadership training and broaden their horizon.</p>
    
    <p>The learning they receive is supported and balanced by skills and knowledge from six subject areas: Language, Mathematics, Science, Social Studies, PSPE (Personal, Social and Physical Education) and Arts which foster the child’s all-round development.</p>

    <p>The PYP aims to create a curriculum that is engaging, relevant, challenging, and significant for the learners between 3–12 years of age. The curriculum is transdisciplinary in that it focuses on issues that go beyond classroom learning.</p>


    <p><b>For more information please visit at:</b><a href="https://www.ibo.org/programmes/primary-years-programme/" target="_blank"> https://www.ibo.org</a></p>
    </div>


    </div> },

{ title: 'Key Aspects of IBPYP Curriculum', content: () => <div>

  <div className='cam-lower-sec'>
    <div className='Footer-top'>
    <div className='footop-img'>
    {/* <div className='footer-img-box'>
      <img src='../img/british-council.webp'/>
    </div> */}
    <div className='footer-img-box'>
    <img src='../img/pyp-programme-logo.webp'/>
      </div>
   
    
    </div>
    
    </div>
      <h1 className='title'>Key Aspects of IBPYP Curriculum:</h1>
       <p>On the whole, the PYP Curriculum is organised according to three main aspects:</p>
       

       <h5 class="cam-title-heading">The written curriculum:</h5>
       <p>The written curriculum comprises five essential elements characteristic to the IB school.</p>
       <br/>
       <h5 class="cam-title-heading">Knowledge:</h5>
       <p>Knowledge which is disciplinary and transdisciplinary. The disciplinary aspect is represented by traditional subject areas (Language, Mathematics, Science, Social Studies, Arts, PSPE).</p>
       <br/>
       <h5 class="cam-title-heading">Concepts:</h5>
       <p>There are 7 Specified concepts which learners explore through structured inquiry to develop a coherent and in-depth understanding which have relevance both within and beyond subject areas.</p>
       
      
       <h5 class="cam-title-heading">The 7 Specified concepts are:</h5>
       <ol>
       <li>Form: What is it like?</li>
        <li>Function: How does it work?</li>
        <li>Causation: Why is it like it is?</li>
        <li>Change: How is it changing?</li>
        <li>Connection: How is it connected to other things?</li>
        <li>Perspective: What are the points of view?</li>
        <li>Responsibility: What is our responsibility?</li>
       </ol>
       <br/>
       <h5 class="cam-title-heading">Approaches to Learning (ATL/Skills):</h5>
       <p>ATL which are the broad capabilities that learners develop and apply during their classroom learning and in life. There are 5 sets of transdisciplinary skills acquired in the process of structured inquiry. These are:</p>

       <ol>
        <li> Thinking</li>
        <li>Communication</li>
        <li>Social</li>
        <li>Research</li>
        <li>Self-Management</li>
      </ol>

      <br/>
      <h5 class="cam-title-heading">Learner Profile:</h5>
      <p>LP which contributes to international-mindedness and the wellbeing of individuals and learning communities.</p>
      <br/>
  
      <h5 class="cam-title-heading">The IB learners strive to be:  </h5>Drawing in their prior knowledge.
        <div className='learners-strive'>
        <ul>
        <li><h3>Inquirers</h3><span>They develop their natural curiosity. They acquire the skills necessary to conduct inquiry and research and show independence in learning. They actively enjoy learning, and this love of learning will be sustained throughout their lives.</span></li>

        <li><h3>Thinkers</h3><span>They exercise initiative in applying thinking skills critically and creatively to recognize and approach complex problems, and make reasoned, ethical decisions.</span></li>

        <li><h3>Communicators</h3><span>They understand and express ideas and information confidently and creatively in more than one language and in a variety of modes of communication. They work effectively and willingly in collaboration with others.</span></li>

        <li><h3>Risk-Takers</h3><span>They approach unfamiliar situations and uncertainty with courage and forethought, and have the independence of spirit to explore new roles, ideas and strategies. They are brave and articulate in defending their beliefs.</span></li>

        <li><h3>Knowledgeable</h3><span>They explore concepts, ideas and issues that have local and global significance. In doing so, they acquire in-depth knowledge and develop understanding across a broad and balanced range of disciplines.</span></li>

        <li><h3>Principled</h3><span>They act with integrity and honesty, with a strong sense of fairness, justice and respect for the dignity of the individual, groups and communities, they take responsibility for their own actions and the consequences that accompany them.</span></li>

        <li><h3>Caring</h3><span>They show empathy, compassion and respect towards the needs and feelings of others. They have a personal commitment to service, and act to make a positive difference to the lives of others and to the environment.</span></li>
       
        <li><h3>Open-Minded</h3><span>They understand and appreciate their own culture and personal histories,and are open to the perspectives, values and traditions of other individuals and communities. They are accustomed to seeking and evaluating a range of points of view, and are willing to grow from the experience.</span></li>

        <li><h3>Balanced</h3><span>They understand the importance of intellectual, physical and emotional balance to achieve personal well-being for themselves and others.</span></li>
        
        <li><h3>Reflective</h3><span>They give thoughtful consideration to their own learning and experience. They are able to assess and understand their strengths and limitations in order to support their learning and personal development.</span></li>

        </ul>
        </div>

      <br/>
        
      <h5 class="cam-title-heading">Action:</h5>
      <p>Action, wherein successful inquiry leads to responsible, thoughtful and appropriate response or change in behavior.</p>
      <br/>
      
      <h5 class="cam-title-heading">The taught curriculum</h5>
      <p>This approach provides students with the learning and space they need to develop ideas. It encourages them to question, consider and refine their understanding of the social and natural world by:</p>
      <br/>
      <ul>
        <li> <p>Drawing in their prior knowledge.</p></li>
        <li>  <p>Providing provocation through new experiences.</p></li>
        <li>    <p>Providing opportunities for reflection and consolidation.</p></li>
      </ul>
     
     
   
      <br/>

      <h5 class="cam-title-heading">The assessed curriculum</h5>
      <p>Through assessments, teachers identify students’ knowledge, their understanding, their capabilities and their preferences at different stages in the teaching and learning process. This input also enables them to plan and adopt effective teaching methods. It is a thoughtful process at Sanskar.</p>
      <p>At Sanskar, learning is a continuous journey. The facilitators, for their part, use a wide range of assessment strategies to collect information on each element of the written curriculum.</p>
      <p>Students are assessed in a variety of ways, including written tests, projects, oral presentations and written reports. Assessment in IB PYP is “criterion referenced.” This means students are scored against set standards using a rubric and checklist. The rubric states what the criteria are for the assignment and what the score will be for addressing or not addressing each point in that criteria. The rubric allows students to take ownership of their effort and learning.</p>
     

      <p><b>For more information please visit at:</b><a href="https://www.ibo.org/programmes/primary-years-programme/" target="_blank"> https://www.ibo.org</a></p>
     
      </div>
  
  
      </div> },

{ title: 'FAQ', content: () => <div>

  <div className='cam-lower-sec'>
    <div className='Footer-top'>
    <div className='footop-img'>
    {/* <div className='footer-img-box'>
      <img src='../img/british-council.webp'/>
    </div> */}
    {/* <div className='footer-img-box'>
    <img src='../img/pyp-programme-logo.webp'/>
      </div> */}
   
    
    </div>
    
    </div>
      <h1 className='title'>FAQ</h1>
       

     
      <FaPypFaq/>
      <p></p>

      <p><b>For more information please visit at:</b><Link to="https://www.ibo.org/programmes/primary-years-programme/"  target="_blank"> https://www.ibo.org</Link></p>
     
      </div>
  
  
      </div> },


  
  ];

  return (
    <div>

<div className='ibdp-hero-sec'>
        <img src='newimg/about-pyp.webp'/>

      </div>
<div className='ib-syllabus  '>
        {/* <Igcsedata/> */}
        {/* <HorizontalTabs tabs={tabs}/> */}

        <HorizontalTabs tabs={tabs} activeTab={formattedTab} />
      </div>

      <div className='ibdp-main-sec'>
    <div className='ibpyp-agency-model'>
    <div className='left-sec'>
  
    </div>
    
    
    </div>




  







    
    </div>
    </div>
  )
}

export default Pyp;


// import React from "react";
// import { useNavigate, useLocation, useParams } from "react-router-dom";
// import HorizontalTabs from "../components/HorizontalTabs";

// function Pyp() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { tab } = useParams(); // Get dynamic part of URL

//   const tabs = [
//     { title: "IB Primary Years Programme", content: () => <h1>IB PYP Content</h1> },
//     { title: "Curriculum at Sanskar", content: () => <h1>Curriculum Content</h1> },
//     { title: "Key Aspects of IBPYP Curriculum", content: () => <h1>Key Aspects Content</h1> },
//     { title: "FAQ", content: () => <h1>FAQ Content</h1> },
//   ];

//   // Find the tab index based on title
//   const activeTabIndex = tabs.findIndex((t) => t.title === decodeURIComponent(tab));
//   const selectedIndex = activeTabIndex !== -1 ? activeTabIndex : 0; // Default to first tab

//   // Redirect to default tab if tab is missing
//   React.useEffect(() => {
//     if (!tab) {
//       navigate(`/pyp/${encodeURIComponent(tabs[0].title)}`, { replace: true });
//     }
//   }, [tab, navigate, tabs]);

//   return (
//     <div>
//       <h1>{tabs[selectedIndex].title}</h1>
//       <HorizontalTabs tabs={tabs} activeTab={selectedIndex} />
//     </div>
//   );
// }

// export default Pyp;
